define([
    "jquery",
    "underscore",
    "marionette",
    "datatables"
], function($, _, Marionette) {
    return Marionette.ItemView.extend({
        initialize: function(config){
            this.config = config || {};

            var that = this;

            this.datatablesEl = this.config.datatablesEl || null;

            if(this.datatablesEl) {
                this.datatables = this.datatablesEl.DataTable(_.extend({
                    'searching': false,
                    'ordering': true,
                    'stateSave': false,
                    'columns': [],
                    "createdRow": function (row, data, dataIndex) {

                    },
                    'deferRender': true,
                    'serverSide': true, // Use server side handling
                    'pageLength': 10, // nbPerPage,
                    'processing': true,
                    'ajax': {
                        type: "POST", // URLs are too long, so let's use POST
                        url: baseUrl + this.config.url,
                        data: function (d) {
                            that._prepareData(d);
                        }

                    },
                    language: {
                        url: baseUrl + '/assets/common/common/js/libs/DataTables/languages/' + lang + '.json'
                    }
                }, this.config));
            }else{
                console.log('You must declare datatablesEl');
            }
        },

        onReloadTable: function(){
            this.datatables.ajax.reload();

            // Its useful sometimes to know in the view
            // when the datable has been reloaded
            this.view.triggerMethod('datatable:reloaded');
        },

        _prepareData: function(d){
            if(this.config.prepareData) {
                this.config.prepareData(d);
            }
            d.length = d.length > -1 ? d.length : 5;
        }
    });
});
